import { RefundStatus } from './RefundStatus';
import { Header } from './Header';

export class RefundStatusRs {
    header?: Header;
    refundStatus?: Array<RefundStatus>;
    validRequest?: boolean;
    errorMessage?: string;
}
